export const PATHS = {
  ROOT: 'notices',
  getOneById: (id: number) => `${PATHS.ROOT}/${id}`,
};
